import useMarketConfig from '@/widgets/hooks/useMarketConfig';
import useRoute from '@/widgets/hooks/useRoute.tsx';
import styles from './TechnologyPicker.module.scss';
import useTranslations from '@/widgets/hooks/useTranslations';
import SkeletonShape from '@/widgets/components/controls/Skeleton/SkeletonShape.tsx';
import FilterDrawer from '../FilterDrawer/FilterDrawer.tsx';
import FilterPicker from '../FilterPicker/FilterPicker.tsx';
import TechnologyList from './TechnologyList.tsx';
import { icons } from './index.ts';
import type { Filter } from '@/domain/FilteringAndSorting.ts';

export default function TechnologyPicker() {
  const marketConfig = useMarketConfig();
  const { technologies } = marketConfig;

  const { t } = useTranslations();
  const route = useRoute();
  const currentTechnology = route.technology;
  const filter = {
    key: 'technology' as Filter['key'],
    options: [],
    label: t(`productList.filters.technologies.${currentTechnology}`)
  };

  if (technologies.length === 1) {
    return null;
  }

  return (
    <>
      <div class={styles.filterDrawerWrapper}>
        <FilterDrawer
          filter={{ ...filter, id: 'technology-mobile' }}
          icon={icons[currentTechnology]}
          headingModal={t('productList.filters.info.technologies.title')}
          class={styles.drawer}
          isSelected
        >
          <TechnologyList />
        </FilterDrawer>
      </div>

      <div class={styles.filterPickerWrapper}>
        <FilterPicker
          filter={{ ...filter, id: 'technology-desktop' }}
          icon={icons[currentTechnology]}
          isSelected
          position="left"
        >
          {(toggle) => <TechnologyList toggle={toggle} />}
        </FilterPicker>
      </div>
    </>
  );
}

TechnologyPicker.Skeleton = function Skeleton() {
  return <SkeletonShape class={styles.skeleton} />;
};
